// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");
var LogicForm$ReactHooksTemplate = require("./LogicForm.res.js");

function RedirectionLogic(props) {
  var saveRedirectionLogics = props.saveRedirectionLogics;
  var redirectionType = props.redirectionType;
  var redirectionDelayUnit = props.redirectionDelayUnit;
  var createRedirectionLogic = props.createRedirectionLogic;
  var removeRedirectionLogics = props.removeRedirectionLogics;
  var updateRedirectionLogic = props.updateRedirectionLogic;
  var redirectionLogics = props.redirectionLogics;
  var survey = props.survey;
  var redirectionUrls = List.length(Survey$ReactHooksTemplate.redirectionUrls(survey));
  var match = Survey$ReactHooksTemplate.id(survey);
  return JsxRuntime.jsx("div", {
              children: match !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        redirectionUrls !== 0 ? JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("h2", {
                                              children: "Redirection Logics",
                                              className: "text-lg font-semibold"
                                            }),
                                        className: "flex justify-between items-center mb-5-px"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("label", {
                                                children: "Redirection Type",
                                                className: "text-sm font-medium text-darkcharcoal"
                                              }),
                                          JsxRuntime.jsxs("select", {
                                                children: [
                                                  JsxRuntime.jsx("option", {
                                                        children: "Automatic",
                                                        value: "automatic"
                                                      }),
                                                  JsxRuntime.jsx("option", {
                                                        children: "Manual",
                                                        value: "manual"
                                                      })
                                                ],
                                                className: "h-10 border border-gray-400 rounded px-3 py-2 text-sm flex-1",
                                                value: FormField$ReactHooksTemplate.getInputValue(redirectionType),
                                                onChange: props.onRedirectionTypeChange
                                              })
                                        ],
                                        className: "flex items-center gap-4 w-1/2"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("label", {
                                                children: "Redirection Description",
                                                className: "text-sm font-medium text-darkcharcoal"
                                              }),
                                          JsxRuntime.jsx("textarea", {
                                                className: "border border-gray-400 rounded px-3 py-2 text-sm",
                                                placeholder: "Description shown to users on the thank you page",
                                                rows: 3,
                                                value: FormField$ReactHooksTemplate.getInputValue(props.redirectionDescription),
                                                onChange: props.onRedirectionDescriptionChange
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: "This description will be displayed for both automatic and manual redirection modes.",
                                                className: "text-xs text-gray-500"
                                              })
                                        ],
                                        className: "flex flex-col gap-2 w-1/2"
                                      }),
                                  FormField$ReactHooksTemplate.getInputValue(redirectionType) === "automatic" ? JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Redirection Delay",
                                                  className: "text-sm font-medium text-darkcharcoal"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("input", {
                                                          className: "w-20 h-10 border border-gray-400 rounded px-3 py-2 text-sm",
                                                          max: FormField$ReactHooksTemplate.getInputValue(redirectionDelayUnit) === "ms" ? "900" : "10",
                                                          min: FormField$ReactHooksTemplate.getInputValue(redirectionDelayUnit) === "ms" ? "100" : "1",
                                                          step: FormField$ReactHooksTemplate.getInputValue(redirectionDelayUnit) === "ms" ? 100.0 : 1.0,
                                                          type: "number",
                                                          value: String(FormField$ReactHooksTemplate.getInputValue(props.redirectionDelay)),
                                                          onChange: props.onRedirectionDelayChange
                                                        }),
                                                    JsxRuntime.jsxs("select", {
                                                          children: [
                                                            JsxRuntime.jsx("option", {
                                                                  children: "Milliseconds",
                                                                  value: "ms"
                                                                }),
                                                            JsxRuntime.jsx("option", {
                                                                  children: "Seconds",
                                                                  value: "s"
                                                                })
                                                          ],
                                                          className: "h-10 border border-gray-400 rounded px-3 py-2 text-sm",
                                                          value: FormField$ReactHooksTemplate.getInputValue(redirectionDelayUnit),
                                                          onChange: props.onRedirectionDelayUnitChange
                                                        })
                                                  ],
                                                  className: "flex items-center gap-2"
                                                })
                                          ],
                                          className: "flex items-center gap-4 w-1/2"
                                        }) : JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Button Text",
                                                  className: "text-sm font-medium text-darkcharcoal"
                                                }),
                                            JsxRuntime.jsx("input", {
                                                  className: "h-10 border border-gray-400 rounded px-3 py-2 text-sm",
                                                  placeholder: "e.g., Continue to Survey",
                                                  type: "text",
                                                  value: FormField$ReactHooksTemplate.getInputValue(props.redirectionButtonText),
                                                  onChange: props.onRedirectionButtonTextChange
                                                })
                                          ],
                                          className: "flex flex-col gap-2 w-1/2"
                                        })
                                ],
                                className: "flex flex-col gap-4"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        redirectionUrls !== 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                children: [
                                  redirectionLogics ? $$Array.of_list(Belt_List.mapWithIndex(redirectionLogics, (function (index, y) {
                                                return JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx(LogicForm$ReactHooksTemplate.make, {
                                                                  survey: survey,
                                                                  logic: y,
                                                                  updateLogic: Curry._1(updateRedirectionLogic, index),
                                                                  deleteLogic: removeRedirectionLogics
                                                                }),
                                                            className: "bg-ghostwhiteblue w-full rounded p-4"
                                                          }, String(index));
                                              }))) : JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("span", {
                                                          children: "🗂️",
                                                          className: "text-2xl text-gray-400 mr-3"
                                                        }),
                                                    "No logics created yet"
                                                  ],
                                                  className: "text-lg text-gray-900 text-lg mb-2"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: "Click 'Add Logic' to create your first logic",
                                                  className: "text-gray-500 text-sm"
                                                })
                                          ],
                                          className: "flex flex-col items-center justify-center py-12 border-2 border-dashed border-gray-300 rounded-lg"
                                        }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        className: "h-14-px mr-2-px",
                                                        src: Image$ReactHooksTemplate.plusCircle
                                                      }),
                                                  "Add Logic"
                                                ],
                                                className: "flex bg-ghostwhite border border-gray-400 shadow-inner rounded py-2\n      px-3 text-xs font-normal cursor-pointer w-40 justify-center items-center mr-2.5",
                                                onClick: (function (param) {
                                                    Curry._1(createRedirectionLogic, undefined);
                                                  })
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("button", {
                                                      children: "Save",
                                                      className: props.edited ? "bg-pigmentblue hover:bg-cetaceanblue px-3 py-2 rounded text-xs text-white font-normal w-40 flex justify-center items-center" : "bg-pigmentblue hover:bg-cetaceanblue px-3 py-2 rounded text-xs text-white font-normal w-40 flex justify-center items-center disabled-input",
                                                      onClick: (function (param) {
                                                          Curry._1(saveRedirectionLogics, undefined);
                                                        })
                                                    }),
                                                className: "flex gap-4"
                                              })
                                        ],
                                        className: "flex justify-end mt-2"
                                      })
                                ]
                              }) : JsxRuntime.jsx("div", {
                                children: "Redirection URLs are missing"
                              })
                      ],
                      className: "flex flex-col gap-4"
                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: "No survey selected. Kindly select a survey"
                    }),
              className: "flex flex-col overflow-y-auto"
            });
}

var make = RedirectionLogic;

exports.make = make;
/* react/jsx-runtime Not a pure module */
